<template>
	<div class="index_body service_body" id="top" :class="isPhone == 'true' ? 'mobile' : ''" style="padding-top: 72px">
		<head-nav></head-nav>
		<div class="banner">
			<div class="fonts">
				<h2>我们期待听到您的声音</h2>
				<div class="banner_btn">
					<div class="btn login_btn" @click="joinBtn">加入QQ群</div>
					<div class="btn more_btn" @click="copyBtn('946014825')">复制群号码</div>
				</div>
				<h4>
					加入数科OFD交流群
					<span>946014825</span>
				</h4>
				<h3>实时在线沟通 ， 想法尽情表达</h3>
			</div>
		</div>
		<div class="change_list_box">
			<img src="@comm/images/document-conversion/home/change_bj.png" alt class="bj" />
			<div class="change_list">
				<div class="item">
					<div class="left">
						<img src="@comm/images/document-conversion/home/bottom_erweima.png" alt />
					</div>
					<div class="right">
						<h2>关注OFD云公众号</h2>
						<p>第一时间了解最新产品动态</p>
					</div>
				</div>
				<div class="item">
					<div class="left">
						<img src="@comm/images/document-conversion/home/sevice_tel.svg" alt />
					</div>
					<div class="right">
						<h2>400-677-5005</h2>
						<p>拨通电话，我们会给您满意的答复</p>
					</div>
				</div>
			</div>
		</div>
		<div class="notice_main">
			<div class="box" @click="jumpNotice">
				<div class="fonts">
					<h2>安全公告</h2>
					<p>数科网维将持续致力提升产品和业务的安全性，构建并守护每一位用户的文档安全免疫系统。数科网维将不断对自身产品进行安全检验，积极与安全专家们建立联系，并面向广大用户公示威胁情报，建设互联网生态安全，共同守护数科网维用户的信息安全。
					</p>
				</div>
			</div>
		</div>
		<div id="downBox" class="zhanwei" name="downBox"></div>
		<div class="title">多端协作 免费下载</div>
		<div class="down_content_new">
			<a class="item" @mouseenter="isDownHover = true" @mouseleave="isDownHover = false">
				<div class="win_down">
					<img v-if="!isDownHover" src="@comm/images/document-conversion/homeSVG/svg_window.png" alt />
					<img v-else src="@comm/images/document-conversion/homeSVG/svg_window_hover.svg" alt />
					<div class="fonts">
						<h2>数科OFD阅读器Windows版</h2>
						<p><span>多格式支持</span><span>签批注释标记</span><span>签名盖章验证</span><span>票据助手</span></p>
					</div>
					<div class="right">
						<div class="list" @click="goDown(1)">Windows版下载</div>
						<div class="list" style="margin-bottom: 0;" @click="goDown(2)">Windows XP版下载</div>
					</div>
				</div>
			</a>
			<a class="item" @mouseenter="isAndroidHover = true" @mouseleave="isAndroidHover = false">
				<img v-if="!isAndroidHover" src="@comm/images/document-conversion/homeSVG/svg_android.png" alt />
				<img v-else src="@comm/images/document-conversion/homeSVG/svg_android_hover.svg" alt />
				<div class="fonts">
					<h2>数科OFD阅读器Android版</h2>
					<p><span>阅读/操作/注释</span><span>原笔迹签批</span><span>签名盖章验证</span><span>语义标引</span></p>
				</div>
				<div class="right">
					<img src="@comm/images/document-conversion/home/wechart_erweima.png" class="erweima" />
				</div>
			</a>
			<a class="item" @mouseenter="isIOSHover = true" @mouseleave="isIOSHover = false">
				<img v-if="!isIOSHover" src="@comm/images/document-conversion/homeSVG/svg_ios.png" alt />
				<img v-else src="@comm/images/document-conversion/homeSVG/svg_ios_hover.svg" alt />
				<div class="fonts">
					<h2>数科OFD阅读器ios版</h2>
					<p><span>发票夹/筛选/星标</span><span>验证发票真伪</span><span>文档页面处理</span><span>发票筛选管理</span></p>
				</div>
				<div class="right">
					<img src="@comm/images/document-conversion/home/wechart_erweima.png" alt class="erweima" />
				</div>
			</a>
			<a class="item" @mouseenter="isWXHover = true" @mouseleave="isWXHover = false">
				<img v-if="!isWXHover" src="@comm/images/document-conversion/homeSVG/svg_wx_mini.png" alt />
				<img v-else src="@comm/images/document-conversion/homeSVG/svg_wx_mini_hover.svg" alt />
				<div class="fonts">
					<h2>数科OFD微信小程序</h2>
					<p><span>跨平台无插件</span><span>文档安全阅读</span><span>签章验证</span><span>协同办公</span></p>
				</div>
				<div class="right">
					<img src="@comm/images/document-conversion/home/xiaochengxu.png" alt class="erweima" />
				</div>
			</a>
		</div>
		<customer-service></customer-service>
		<footer-nav></footer-nav>
	</div>
</template>

<script>
import footerNav from "@comm/components/document-conversion/footerPage";
import headNav from "@comm/components/document-conversion/headerPage";
import customerService from "@comm/components/document-conversion/customerService";
import { downPcReader } from "@comm/api/document-conversion";
import { copyText } from "@comm/utils/tools";
export default {
	components: { footerNav, customerService, headNav },
	name: "index",
	data() {
		return {
			currentJump: "",
			isPhone: "",
			isDownHover: false,
			isAndroidHover: false,
			isIOSHover: false,
			isWXHover: false,
			winLink: "",
			andLink: "",
			timer: null
		};
	},
	created() {
		this.andLink = localStorage.andLink;
		this.winLink = localStorage.winLink;
		this.isPhone = localStorage.getItem("isPhone");
		document.title = "联系我们";
		this.$nextTick(() => {
			this.toScoll();
		});
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				let targetbox = document.getElementById("downBox");
				localStorage.setItem("target", targetbox.offsetTop);
			});
		});
	},
	watch: {

	},
	computed: {},
	methods: {
		jumpNotice(){
			this.$router.push({path:'/announcement'})
		},
		goDown(type) {
			if (this.timer) clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				downPcReader({ dictionaryId: type == 1 ? "135" : "137" })
					.then((res) => { })
					.catch(() => { });
				window.open(type == 1 ? localStorage.winLink : localStorage.andLink, "_self");
			}, 300);
		},
		toguid(path, id) {
			var path = path;
			var Id = id;
			localStorage.setItem("toId", Id);
			this.$router.push(path);
		},
		jumpPage(path, type) {
			this.currentJump = type;
			this.$router.push({ path: path });
		},
		//复制
		copyBtn(data) {
			copyText(data)
			// let oInput = document.createElement("input");
			// oInput.value = data;
			// document.body.appendChild(oInput);
			// oInput.select(); // 选择对象;
			// document.execCommand("Copy"); // 执行浏览器复制命令
			// this.$message({
			// 	message: "复制成功",
			// 	type: "success"
			// });
			// document.body.removeChild(oInput);
		},
		joinBtn() {
			window.open("https://jq.qq.com/?_wv=1027&k=buqIcKXH");
		},
		toScoll() {
			//查找存储的锚点id
			let Id = localStorage.getItem("toNavId");
			let toElement = document.getElementById(Id);
			//锚点存在跳转
			if (Id) {
				toElement.scrollIntoView();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.notice_main {
	width: 100%;
	background: linear-gradient(135deg, rgba(248, 250, 255, .56) 0%, rgba(245, 247, 255, .56) 100%);
	margin: 80px 0 0;

	.box {
		width: 1200px;
		padding: 31px 53px;
		margin: 0 auto;
		cursor: pointer;

		.fonts {
			background: url(../../comm/images/document-conversion/notice/notice_icon_03.png) left center no-repeat;
			background-size: 202px 133px;
			padding-left: 298px;
			position: relative;
			&::before{
				content: '';
				width: 1px;
height: 119px;
border: 1px solid rgba(0,0,0,0.08);
position: absolute;
left: 256px;
top: 50%;
transform: translateY(-50%);
			}

			h2 {
				font-size: 28px;
				padding-bottom: 8px;
				font-weight: 500;
				color: #383E45;
				line-height: 40px;
			}

			p {
				font-size: 16px;
				font-weight: 400;
				color: #8B97AF;
				line-height: 28px;
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/servicePages.vue